var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91,346H88a3,3,0,0,0-3-3H83a3,3,0,0,0-3,3H77a1,1,0,0,0,0,2h1v8a3,3,0,0,0,3,3h6a3,3,0,0,0,3-3v-8h1a1,1,0,0,0,0-2Zm-8-1h2a1,1,0,0,1,1,1H82A1,1,0,0,1,83,345Zm5,11a1,1,0,0,1-1,1H81a1,1,0,0,1-1-1v-8h8Zm-3.5-6v5a.5.5,0,0,1-1,0v-5a.5.5,0,0,1,1,0Zm2,1v3a.5.5,0,0,1-1,0v-3a.5.5,0,0,1,1,0Zm-4,0v3a.5.5,0,0,1-1,0v-3a.5.5,0,0,1,1,0Z",
    transform: "translate(-72 -339)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.0684c2fc.svg";
export { ForwardRef as ReactComponent };